import { useLocalStorage as useLS } from 'react-use';

export type LocalStorageKeys = 'ViewedProducts' | 'paymentInstrumentKey' | 'paymentMethodKey';

export function useLocalStorage<T>(key: LocalStorageKeys, initialValue?: T) {
    return useLS(key, initialValue);
}
